import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Input, TextArea, Select, Search} from 'semantic-ui-react';
import {reverseShortDate} from '../../../../../../common/constants/datesFormat';
import {getSearchOptions} from '../../../../../utils';
import {Actions} from '../../../../../../common/actions';

const Divisor = ({text, bulletinId}) => {
  return (
    <p className="bulletin-divisor">
      {text}
      {bulletinId && <span>{bulletinId}</span>}
    </p>
  );
};

const initialState = {
  'modelLoading': false,
  'katashikiLoading': false,
  'openModel': false,
  'resultsModel': [],
  'openKatashiki': false,
  'resultsKatashiki': [],
};

class BulletinForm extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidUpdate(prevProps) {
    const {modelList, katashikiList, loading} = this.props;
    if (prevProps.loading && !loading) {
      if (prevProps.loading !== modelList.length) {
        this.setState({
          'resultsModel': getSearchOptions(modelList, 'model'),
          'openModel': false,
          'modelLoading': false,
        });
      }
      if (prevProps.katashikiList.length !== katashikiList.length) {
        this.setState({
          'resultsKatashiki': getSearchOptions(katashikiList, 'katashiki'),
          'openKatashiki': false,
          'katashikiLoading': false,
        });
      }
      this.setState({
        'modelLoading': false,
        'katashikiLoading': false,
      });
    }
  }

  parseVehicleSystems = (list = []) => {
    return list.map((element, idx) => ({
      'key': idx,
      'text': element.description,
      'value': element.code,
    }));
  };

  handleSearchChange = (e, {name, value}) => {
    const {onUpdateForm} = this.props;
    const finalValue = value.toUpperCase();
    onUpdateForm(e, {name, value});
    if (value.length > 1) {
      const loadingName = `${name}Loading`;
      this.setState({[loadingName]: true});
      this.props.fetchVehicleQuery({[name]: finalValue});
    }
  };

  render() {
    const {
      bulletinId,
      type,
      model,
      katashiki,
      subject,
      symptom,
      cause,
      fix,
      edit,
      id,
      createdDate,
      countermeasure,
      production,
      partsInfo,
      petition,
      onUpdateForm,
      vehicleSystems,
    } = this.props;
    const {resultsModel, resultsKatashiki, modelLoading, katashikiLoading} = this.state;
    const formatDate = createdDate.format(reverseShortDate);

    return (
      <Form>
        <Divisor text='Boletín Id' bulletinId={bulletinId} />
        <Form.Group widths='three'>
          <Form.Field
            value={type}
            name='type'
            control={Select}
            options={this.parseVehicleSystems(vehicleSystems)}
            disabled={!edit || !!id}
            onChange={onUpdateForm}
            label='Sistema de vehículo'
            placeholder='Seleccione el tipo de sistema de vehículo'
            required
          />
          <Form.Field
            value={formatDate}
            control={Input}
            readOnly
            label='Fecha publicación'
            placeholder='Fecha publicación'
          />
          <Form.Field />
        </Form.Group>
        <Form.Group widths='three'>
          <Form.Field
            value={katashiki}
            control={Search}
            disabled={!edit || !!id}
            loading={katashikiLoading}
            results={resultsKatashiki}
            showNoResults={false}
            name='katashiki'
            onResultSelect={(e, {name, result}) =>
              onUpdateForm(e, {name, 'value': result.title})
            }
            onSearchChange={this.handleSearchChange}
            label='Katashiki'
            placeholder='Katashiki'
          />
          <Form.Field
            value={model}
            control={Search}
            onResultSelect={(e, {name, result}) =>
              onUpdateForm(e, {name, 'value': result.title})
            }
            loading={modelLoading}
            results={resultsModel}
            onSearchChange={this.handleSearchChange}
            disabled={!edit || !!id}
            showNoResults={false}
            label='Modelo'
            name='model'
            placeholder='Modelo'
          />
          <Form.Field />
        </Form.Group>
        <Form.Group widths='one'>
          <Form.Field
            value={subject}
            control={TextArea}
            onChange={onUpdateForm}
            readOnly={!edit || !!id}
            required
            name='subject'
            label='Asunto'
            placeholder='Asunto'
          />
        </Form.Group>
        <Form.Group widths='one'>
          <Form.Field
            value={symptom}
            control={TextArea}
            onChange={onUpdateForm}
            readOnly={!edit}
            label='Sintoma'
            name='symptom'
            placeholder='Síntoma'
          />
        </Form.Group>
        <Form.Group widths='one'>
          <Form.Field
            value={cause}
            control={TextArea}
            onChange={onUpdateForm}
            readOnly={!edit}
            label='Causa'
            name='cause'
            placeholder='Causa'
          />
        </Form.Group>
        <Form.Group widths='one'>
          <Form.Field
            value={fix}
            control={TextArea}
            onChange={onUpdateForm}
            readOnly={!edit}
            name='fix'
            label='F/Fix'
            placeholder='F/Fix'
          />
        </Form.Group>
        <Form.Group widths='one'>
          <Form.Field
            value={countermeasure}
            control={TextArea}
            readOnly={!edit}
            onChange={onUpdateForm}
            name='countermeasure'
            label='Contramedida'
            placeholder='Contramedida'
          />
        </Form.Group>
        <Form.Group widths='one'>
          <Form.Field
            value={production}
            control={TextArea}
            readOnly={!edit}
            onChange={onUpdateForm}
            name='production'
            label='Producción efectiva con implementación de C/M'
            placeholder='Producción efectiva con implementación de C/M'
          />
        </Form.Group>
        <Form.Group widths='one'>
          <Form.Field
            value={partsInfo}
            control={TextArea}
            readOnly={!edit}
            onChange={onUpdateForm}
            name='partsInfo'
            label='Información sobre pedido de partes'
            placeholder='Información sobre pedido de partes'
          />
        </Form.Group>
        <Form.Group widths='one'>
          <Form.Field
            value={petition}
            control={TextArea}
            readOnly={!edit}
            onChange={onUpdateForm}
            name='petition'
            label='Petición'
            placeholder='Petición'
          />
        </Form.Group>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'vehicleSystems': state.vehicleSystems.list,
    'modelList': state.vehicleQuery.modelList,
    'katashikiList': state.vehicleQuery.katashikiList,
    'loading': state.vehicleQuery.loading,
  };
};

const {
  fetchVehicleQuery,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchVehicleQuery,
  navigateTo,
})(BulletinForm);
